export { default as SideImageCard } from './SideImageCard';
